import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { ComboService } from "../../../services/combo.service";
import { SaleDC } from "../../../services/salesDc.service";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditDc",
  templateUrl: "./addEditDc.html",
})
export class DcEntryComponent {
  design_id: any;
  row: any;
  data: any;
  sampledata: any = {};
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  dcdata: any = {
    wo_id: "",
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    totqty: 0,
    fqty: 0,
    hqty: 0,
    type: "Fresh",
  };
  invoicedata: any = {
    corcharge: 0,
    boxless: 0,
    taxper: 0,
    disper: 0,
    salesorder: false,
  };
  delPartyList: any;
  party_id: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  woList: any;
  designList: any;
  invalidList: any = [];
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  designnoList = [];
  isChecked: boolean = false;
  typeList = [{ name: "Fresh" }, { name: "Damage" }];
  partyList: any;
  sm_type: any;
  checked: boolean = true;
  export: boolean = false;

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sm_type = val["sale_type"];

    this.saveEvent = val["data"].tabevent;
    let dcdata = Object.assign({}, val["data"]);
    // this.dcdata = dcdata;
    // this.sampledata.sample_type = sampledata.sample_type ;
    if (this.mode == "Edit") {
      this.dcdata = dcdata;
      this.dcdata.f36 = 0;
      this.dcdata.f38 = 0;
      this.dcdata.f40 = 0;
      this.dcdata.f42 = 0;
      this.dcdata.f44 = 0;
      this.dcdata.f46 = 0;
      this.dcdata.h36 = 0;
      this.dcdata.h38 = 0;
      this.dcdata.h40 = 0;
      this.dcdata.h42 = 0;
      this.dcdata.h44 = 0;
      this.dcdata.h46 = 0;
      this.dcdata.wo_no = "";
      this.dcdata.design_no = "";
      this.dcdata.dispName = "";
      this.dcdata.totqty = 0;
      //  this.dcdata.dispName = dcdata.code;
      this.dcdata.type = "Fresh";
      this.loadDC();
      this.calcTot();
      //this.summarytot();
    }
    this.getDesignNoList();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("codeAuto") codeAuto;
  colorControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  woControl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    private dcservice: SaleDC,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private comboService: ComboService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      barcodeList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.dcdata.mode = this.mode;
    if (this.mode == "Add") {
      this.dcdata.dc_dt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAutoNumber();
    }
    this.getOpenWorkOrder();
    //this.checked = true;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#wono").focus();
    }, 100);
  }
  tableScroll() {
    $(".pobody").height(window.innerHeight - 400);
    $(".pobody").width(window.innerWidth - 30);
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      $("#" + nextEl).focus();
    }
  }
  getDesignNoList() {
    let params = {};
    this.comboService.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.barcodeList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.barcodeList.length > 1) {
          that.data.barcodeList.splice(ind, 1);
          that.summarytot();

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      sm_type: this.sm_type,
    };
    this.dcservice.dcAutoNumber(params).then((res: any) => {
      this.dcdata.dc_no = res.dc_no;
    });
  }

  getOpenWorkOrder() {
    this.dcservice.getOpenWorkOrder({}).then((res: any) => {
      this.woList = res;
    });
  }
  getWorkorderDesign(wono) {
    let wolist = _.filter(this.woList, { wo_no: wono });
    this.dcdata.wo_id = wolist[0]["wo_id"];
    let params = {
      page: 1,
      start: 0,
      limit: 100,
      wo_id: this.dcdata.wo_id,
    };
    this.dcservice.getWorkorderDesign(params).then((res: any) => {
      this.designList = res;
      $("#desno").focus();
    });
  }

  getDesignColorList(desno) {
    let designlist = _.filter(this.designnoList, { design_no: desno });
    this.dcdata.des_id = designlist[0]["des_id"];
    let params = {
      page: 1,
      start: 0,
      limit: 100,
      des_id: this.dcdata.des_id,
    };
    this.dcservice.getDesignColorList(params).then((res: any) => {
      this.design_id = res[0].design_id;

      this.colorList = res;
      $("#color").focus();
    });
  }

  checkBarcode(code) {
    if (code.length == 7) {
      let params = {
        barcode: code,
      };
      for (let i = 0; i < this.data.barcodeList.length; i++) {
        if (this.data.barcodeList[i].barcode == code) {
          swal("Barcode Already Exists");
          this.sampledata.barcode = "";
          return;
        }
      }

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (res.data.length == 0) {
          swal("Selected Design is invalid!");
          let invalidData = {
            barcode: code,
            type: "invoice",
          };
          this.invalidList.push(invalidData);
          this.sampledata.barcode = "";
          return;
        }
        let row = Object.assign(
          {
            f36: 0,
            f38: 0,
            f40: 0,
            f42: 0,
            f44: 0,
            f46: 0,
            h36: 0,
            h38: 0,
            h40: 0,
            h42: 0,
            h44: 0,
            h46: 0,
          },
          res.data
        );
        row[row.size.toLowerCase()] = 1;
        row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
        row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
        row.totqty = row.hqty + row.fqty;
        this.data.barcodeList.push(row);
        // this.calctot();
        this.sampledata.barcode = "";
      });
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    let design = this.data.barcodeList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.barcodeList = desList;
    this.addDc();
  }

  onSelectColor(color) {
    let colorlist = _.filter(this.colorList, { dispName: color });
    this.dcdata.design_id = colorlist[0]["design_id"];
    $("#f36").focus();
  }

  addDc(): void {
    // let params: any = Object.assign({}, this.dcdata);
    let temp: any = this.data.barcodeList;
    for (var k = 0; k < temp.length; k++) {
      let temp1 = temp[k];
      temp1.design_id = this.design_id;
      temp1.type = "DC";
    }

    let params = {
      dc_id: this.dcdata.dc_id || 0,
      dc_no: this.dcdata.dc_no,
      dc_det: JSON.stringify(this.data.barcodeList),
      dc_dt: this.datePipe.transform(this.dcdata.dc_dt, "yyyy-MM-dd"),
    };

    let that = this;
    that.isLoading = true;
    swal({
      title: "Are you sure to save this DC?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.dcservice
        .addDc(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (that.checked == true) {
            that.print();
          }
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

  print() {
    let params = {
      noofpcs: 2,
      export: this.export,
      designdet: JSON.stringify(this.data.barcodeList),
    };
    this.dcservice.print(params).then((res: any) => {});
  }

  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });
    this.invoicedata.agent_id = partylist[0]["agent_id"];
    this.invoicedata.party_id = partylist[0]["genLedid"];
  }
  loadDC() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dc_id: this.dcdata.dc_id,
    };
    this.dcservice.loadDC(params).then((res: any) => {
      this.data.barcodeList = res.data;
      for (let i = 0; i < this.data.barcodeList.length; i++) {
        this.data.barcodeList[i].fqty =
          this.data.barcodeList[i]["f36"] +
          this.data.barcodeList[i]["f38"] +
          this.data.barcodeList[i]["f40"] +
          this.data.barcodeList[i]["f42"] +
          this.data.barcodeList[i]["f44"] +
          this.data.barcodeList[i]["f46"];
        this.data.barcodeList[i].hqty =
          this.data.barcodeList[i]["h36"] +
          this.data.barcodeList[i]["h38"] +
          this.data.barcodeList[i]["h40"] +
          this.data.barcodeList[i]["h42"] +
          this.data.barcodeList[i]["h44"] +
          this.data.barcodeList[i]["h46"];
        this.data.barcodeList[i].totqty =
          this.data.barcodeList[i].fqty + this.data.barcodeList[i].hqty;
        ftot += this.data.barcodeList[i]["fqty"];
        htot += this.data.barcodeList[i]["hqty"];
        tot += this.data.barcodeList[i]["totqty"];
      }
      this.dcdata.ftotal = ftot;
      this.dcdata.htotal = htot;
      this.dcdata.total = tot; // this.calctot();
    });
  }
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calcTot() {
    let tot = 0,
      htot = 0,
      ftot = 0;
    this.dcdata.f36 = this.dcdata.f36 == "" ? 0 : this.dcdata.f36;
    this.dcdata.f38 = this.dcdata.f38 == "" ? 0 : this.dcdata.f38;
    this.dcdata.f40 = this.dcdata.f40 == "" ? 0 : this.dcdata.f40;
    this.dcdata.f42 = this.dcdata.f42 == "" ? 0 : this.dcdata.f42;
    this.dcdata.f44 = this.dcdata.f44 == "" ? 0 : this.dcdata.f44;
    this.dcdata.h36 = this.dcdata.h36 == "" ? 0 : this.dcdata.h36;
    this.dcdata.f38 = this.dcdata.f38 == "" ? 0 : this.dcdata.f38;
    this.dcdata.f40 = this.dcdata.f40 == "" ? 0 : this.dcdata.f40;
    this.dcdata.f42 = this.dcdata.f42 == "" ? 0 : this.dcdata.f42;
    this.dcdata.f44 = this.dcdata.f44 == "" ? 0 : this.dcdata.f44;
    this.dcdata.f46 = this.dcdata.f42 == "" ? 0 : this.dcdata.f46;
    this.dcdata.f46 = this.dcdata.f46 == "" ? 0 : this.dcdata.f46;
    tot =
      parseInt(this.dcdata.f36) +
      parseInt(this.dcdata.f38) +
      parseInt(this.dcdata.f40) +
      parseInt(this.dcdata.f42) +
      parseInt(this.dcdata.f44) +
      parseInt(this.dcdata.f46) +
      parseInt(this.dcdata.h36) +
      parseInt(this.dcdata.h38) +
      parseInt(this.dcdata.h40) +
      parseInt(this.dcdata.h42) +
      parseInt(this.dcdata.h44) +
      parseInt(this.dcdata.h46);
    ftot =
      parseInt(this.dcdata.f36) +
      parseInt(this.dcdata.f38) +
      parseInt(this.dcdata.f40) +
      parseInt(this.dcdata.f42) +
      parseInt(this.dcdata.f44) +
      parseInt(this.dcdata.f46);
    htot =
      parseInt(this.dcdata.h36) +
      parseInt(this.dcdata.h38) +
      parseInt(this.dcdata.h40) +
      parseInt(this.dcdata.h42) +
      parseInt(this.dcdata.h44) +
      parseInt(this.dcdata.h46);
    this.dcdata.hqty = htot;
    this.dcdata.fqty = ftot;
    if (isNaN(tot)) {
      this.dcdata.totqty = 0;
    } else {
      this.dcdata.totqty = tot;
    }
  }

  pushBarcode() {
    if (
      this.dcdata.wo_no == "" ||
      this.dcdata.design_no == "" ||
      this.dcdata.dispName == "" ||
      this.dcdata.totqty <= 0
    ) {
      swal("Make sure that Design No,Wo No,Qty were entered!");
    } else {
      this.dcdata.barcode = "NEW";
      this.dcdata.tabevent = undefined;
      this.data.barcodeList.push(Object.assign({}, this.dcdata));
      this.summarytot();
      this.dcdata.f36 = 0;
      this.dcdata.f38 = 0;
      this.dcdata.f40 = 0;
      this.dcdata.f42 = 0;
      this.dcdata.f44 = 0;
      this.dcdata.f46 = 0;
      this.dcdata.h36 = 0;
      this.dcdata.h38 = 0;
      this.dcdata.h40 = 0;
      this.dcdata.h42 = 0;
      this.dcdata.h44 = 0;
      this.dcdata.h46 = 0;
      this.dcdata.wo_no = "";
      this.dcdata.design_no = "";
      this.dcdata.dispName = "";
      this.dcdata.totqty = 0;
      $("#wono").focus();
    }
  }
  click(check) {
    this.checked = check.checked;
  }
  clickExport(check) {
    this.export = check.checked;
  }

  summarytot() {
    let ftot = 0,
      htot = 0,
      tot = 0;
    for (let i = 0; i < this.data.barcodeList.length; i++) {
      ftot += parseInt(this.data.barcodeList[i]["fqty"]);
      this.dcdata.ftotal = ftot;
      htot += parseInt(this.data.barcodeList[i]["hqty"]);
      this.dcdata.htotal = htot;
      tot += parseInt(this.data.barcodeList[i]["totqty"]);
      this.dcdata.total = tot;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/Dc/addEditDc.ts